import {
  Button,
  CardContent,
  CircularProgress,
  DialogContent,
  DialogContentText,
  IconButton,
  Typography,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Tooltip from "@material-ui/core/Tooltip";
import CancelIcon from "@material-ui/icons/Cancel";
import DoneIcon from "@material-ui/icons/Done";
import EditIcon from "@material-ui/icons/Edit";
import ViewIcon from "@material-ui/icons/Visibility";
import moment from "moment";
import React, { Component } from "react";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { compose } from "redux";
import { loadBeneficiary } from "../../actions";
import performRequest from "../../configAxios";
import AbtcAvatar from "../../custom/Avatar";
import FormDialog from "../../custom/FormDialog";
import NumberFormat from "../../custom/Number";
import wpp from "../../static/whatsapp.png";
import { HierarchyViewTypeEnum, Roles, capitalCaseNormalizer, isAgent, isAgentManager, isUserBelowManager, phoneFormatter, userDocumentFormatter } from "../../util";
import InfoItem from "../../custom/InfoItem";
import UserTagStatus from "./UserTagStatus";
import * as actions from "../../actions";
import FormChangeRecommender from "./FormChangeRecommender";

class UserDetail extends Component {
  state = {
    loading: true,
    loadingDialog: false,
    user: {},
    currentUser: {},
    showChangeAgentDialog: false,
    showChangeRecommenderDialog: false,
    showClearAgentConfirmation: false,
    showClearRecommenderConfirmation: false,
    showBeneficiaryDialog: false,
    recommenders: [],
    recommenderId: null,
    recommenderName: "",
    recommenderPercent: null,
    selectedRecommender: null,
  };

  componentDidMount() {
    this.loadData();
    this.setState({
      user: this.props.user,
      currentUser: this.props.currentUser,
    });
  }

  componentDidUpdate(prevProps) {
    const { forceUpdate } = this.props;
    if (this.props.user !== prevProps.user || this.props.currentUser.apt !== prevProps.currentUser.apt || forceUpdate !== prevProps.forceUpdate) {
      this.loadData();
    }
  }

  loadData = () => {
    const { currentUser, user } = this.props;
    //const { user } = this.state;
    performRequest("GET", `/user/${user}`, null, true)
      .then((response) => {
        let user = response.data.data;
        this.setState({
          loading: false,
          user: user,
          recommenderPercent: user.recommenderPercent ?? 0.3,
        });
        loadBeneficiary(user.id).then((beneficiary) => this.setState({ user: { ...user, beneficiary } }));
      })
      .catch((e) => {
        this.props.history.push("/notfound");
      });
  };

  clearRecommender = () => {
    const { user } = this.state;
    actions.clearRecommender(user.id).then((data) => {
      this.loadData();
      this.setState({ user: data, showClearRecommenderConfirmation: false });
    });
  };

  userDocumentType = (document, personType) => {
    if (document == "NIT" && personType == "NATURAL_PERSON") {
      return <FormattedMessage id={`app.cedula`} />;
    } else {
      return <FormattedMessage id={`app.enuns.${document}`} />;
    }
  };

  render() {
    const { loading, user, currentUser, showBeneficiaryDialog } = this.state;
    const { showButtonsToEdit = true } = this.props;

    const roleLabel =
      user.role === Roles.Agent ? <FormattedHTMLMessage id={`app.enuns.levelName.${user.contractAgent.contractAgentClass.levelName}`} /> : <FormattedHTMLMessage id={`app.enuns.${user.role}`} />;

    if (loading) return <CircularProgress style={{ marginTop: "25%" }} />;

    const canEdit = showButtonsToEdit && ([Roles.Admin, Roles.FinanceManager].includes(currentUser.role) || isUserBelowManager(user, currentUser));
    return (
      <CardContent>
        {!this.props.hideAvatar && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: 16,
            }}
          >
            <AbtcAvatar
              imageUrl={user.photoUrl}
              disableLink
              size={120}
            />
          </div>
        )}

        {/* nome */}
        <Typography
          color="textSecondary"
          variant="caption"
        >
          {user.id}
          {" - "}
          {roleLabel}
          <UserTagStatus
            variant="body2"
            apt={user.apt}
            isBlocked={user.isBlocked}
            premium={user.premium}
          />
        </Typography>
        <Typography
          color={user.premium ? "primary" : undefined}
          paragraph
        >
          {user.name}
        </Typography>

        {/* telefones */}
        <Typography
          color="textSecondary"
          variant="caption"
        >
          <FormattedMessage id="app.phone" />
        </Typography>
        <Typography
          paragraph
          component="div"
        >
          {!user.telefone && !user.telefone2 ? (
            <FormattedMessage id="app.empty" />
          ) : (
            <>
              {user.telefone && (
                <div>
                  {phoneFormatter(user.telefone)}{" "}
                  {user.isWhats && (
                    <a
                      href={"https://wa.me/55" + user.telefone}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={wpp}
                        width="14"
                        height="14"
                        alt=" "
                      />
                    </a>
                  )}
                </div>
              )}
              {user.telefone2 && (
                <div>
                  {phoneFormatter(user.telefone2)}{" "}
                  {user.isWhats2 && (
                    <a
                      href={"https://wa.me/55" + user.telefone2}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={wpp}
                        width="14"
                        height="14"
                        alt=" "
                      />
                    </a>
                  )}
                </div>
              )}
            </>
          )}
        </Typography>
        {/* email */}
        {!user.emailConfirmed ? (
          <>
            <Typography
              color="textSecondary"
              variant="caption"
            >
              <FormattedMessage id="app.email" />{" "}
              <span style={{ color: "red" }}>
                <FormattedMessage id="app.not.confirmed" />
              </span>
            </Typography>
            <Typography paragraph>{user.email}</Typography>
          </>
        ) : (
          <>
            <Typography
              color="textSecondary"
              variant="caption"
            >
              <FormattedMessage id="app.email" />
            </Typography>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: -4,
              }}
            >
              <Typography paragraph>
                {user.email}
                <IconButton
                  size="small"
                  disabled
                  style={{ color: "green" }}
                >
                  <DoneIcon />
                </IconButton>
              </Typography>
            </div>
          </>
        )}

        {/* domicilio fiscal */}
        <Typography
          color="textSecondary"
          variant="caption"
        >
          <FormattedMessage id="app.taxResidence" />
        </Typography>
        <Typography paragraph>
          <FormattedMessage id={`app.taxResidence.${user.taxResidence}`} />
        </Typography>

        {/* documentos */}
        <Typography
          color="textSecondary"
          variant="caption"
        >
          {this.userDocumentType(user.documentType, user.type)}
          {/* <FormattedMessage id={`app.enuns.${user.documentType}`} /> */}
        </Typography>
        <Typography paragraph>{userDocumentFormatter(user, <FormattedMessage id="app.empty" />)}</Typography>
        {user.isPj && (
          <>
            <Typography
              color="textSecondary"
              variant="caption"
            >
              <FormattedMessage id="app.legalRepresentativeName" />
            </Typography>
            <Typography paragraph>{user.legalRepresentativeName ? user.legalRepresentativeName : <FormattedMessage id="app.empty" />}</Typography>

            <Typography
              color="textSecondary"
              variant="caption"
            >
              <FormattedMessage id="app.legalRepresentativeDocumentId" />
            </Typography>
            <Typography paragraph>{user.legalRepresentativeId ?? <FormattedMessage id="app.empty" />}</Typography>
          </>
        )}
        {!user.isPj && (
          <>
            {/* data de nascimento */}
            <Typography
              color="textSecondary"
              variant="caption"
            >
              <FormattedMessage id="app.dateOfBirth" />
            </Typography>
            <Typography paragraph>{user.dateOfBirth ? moment(user.dateOfBirth).format("DD/MM/YYYY") : <FormattedMessage id="app.empty" />}</Typography>
          </>
        )}

        {/* gênero */}
        <Typography
          color="textSecondary"
          variant="caption"
        >
          <FormattedMessage id="app.gender" />
        </Typography>
        <Typography
          variant="body1"
          paragraph
        >
          {user?.gender ? <FormattedMessage id={`app.gender.${user.gender}`} /> : <FormattedMessage id="app.notAvailable" />}
        </Typography>

        {/* endereço */}
        <Typography
          color="textSecondary"
          variant="caption"
        >
          <FormattedMessage id="app.address" />
        </Typography>
        <Typography paragraph>
          {user.address ? user.address : "N/D"}, {user.city ? user.city : "N/D"} - {user.state ? user.state : "N/D"} - {user.country ? user.country : "N/D"}
        </Typography>

        {/* data de cadastro */}
        <Typography
          color="textSecondary"
          variant="caption"
        >
          <FormattedMessage id="app.dateRegister" />
        </Typography>
        <Typography paragraph>{moment(user.createdAt).format("DD/MM/YYYY")}</Typography>

        {/* idioma */}
        <Typography
          color="textSecondary"
          variant="caption"
        >
          <FormattedMessage id="app.language" />
        </Typography>
        <Typography paragraph>
          <FormattedMessage id={`app.language.${user.locale}`} />
        </Typography>

        {/* perfil */}
        <Typography
          color="textSecondary"
          variant="caption"
        >
          <FormattedMessage id="app.role" />
        </Typography>
        <Typography paragraph>{roleLabel}</Typography>

        {/* status do service agreement */}
        {user.role === Roles.Agent &&
          (user.contractAgent ? (
            <>
              {user.contractAgent.signatureDate ? (
                <>
                  <Typography
                    gutterBottom
                    color="textSecondary"
                    variant="caption"
                  >
                    <FormattedHTMLMessage id="app.contractAgent" />
                  </Typography>
                  <Typography>
                    <FormattedMessage id={`app.enuns.${user.contractAgent.status}`} /> <FormattedMessage id="app.contractAgent.signed" />
                    {moment(user.contractAgent.signatureDate).format("DD/MM/YYYY")}
                  </Typography>
                </>
              ) : (
                <>
                  <Typography
                    gutterBottom
                    color="textSecondary"
                    variant="caption"
                  >
                    <FormattedHTMLMessage id="app.contractAgent" />
                  </Typography>
                  <Typography>
                    <FormattedMessage id={`app.enuns.${user.contractAgent.status}`} />
                  </Typography>
                </>
              )}
              {canEdit && (isAgent(user) || isAgentManager(user)) && (
                <Typography variant="caption">
                  <FormattedMessage id="app.contractAgent.commissionLimit" />
                  <NumberFormat
                    value={1 - user.contractAgent.splitForManager}
                    display="percentage"
                  />
                </Typography>
              )}
              <Typography paragraph>{/*espaçador*/}</Typography>
            </>
          ) : (
            <>
              <Typography
                gutterBottom
                color="textSecondary"
                variant="caption"
              >
                <FormattedHTMLMessage id="app.contractAgent" />
              </Typography>
              <Typography
                paragraph
                color="error"
              >
                <b>
                  <FormattedMessage id="app.none" />
                </b>
              </Typography>
            </>
          ))}

        {/* agente */}
        {user.consultant ? (
          <>
            <Typography
              color="textSecondary"
              variant="caption"
            >
              {user.consultant.id} {" - "}
              <FormattedMessage id="app.agent.assigned" />
            </Typography>
            <div
              color="textSecondary"
              style={{ display: "flex" }}
            >
              <Typography
                paragraph
                color="textPrimary"
                style={{ alignSelf: "center", textDecoration: "none" }}
                component={[Roles.Admin, Roles.BusinessManager, Roles.Auditor].includes(currentUser.role) ? Link : null}
                to={`/user/${user.consultant.id}`}
              >
                {capitalCaseNormalizer(user.consultant.name)}
              </Typography>
            </div>
          </>
        ) : (
          <>
            {currentUser.role === Roles.Admin && user.role !== Roles.Admin && (
              <Button
                disabled={currentUser.role == Roles.Kyc}
                style={{ marginTop: 16 }}
                fullWidth
                variant="outlined"
                onClick={(e) => {
                  this.setState({ showChangeAgentDialog: true });
                }}
              >
                <FormattedMessage id="app.addAgent" />
              </Button>
            )}
          </>
        )}

        {/* recomendante */}
        {canEdit && (
          <>
            <Typography
              color="textSecondary"
              variant="caption"
            >
              {user.recommender?.id} {" - "}
              <FormattedMessage id="app.recommender.assigned" />
            </Typography>
            {user.recommender ? (
              <>
                <div
                  color="textSecondary"
                  style={{ display: "flex" }}
                >
                  <Typography
                    paragraph
                    color="textPrimary"
                    style={{ alignSelf: "center", textDecoration: "none" }}
                    component={
                      currentUser.role == Roles.Admin || currentUser.role == Roles.BusinessManager || currentUser.role == Roles.Auditor || currentUser.role == Roles.AgentsManager ? Link : null
                    }
                    to={`/user/${user.recommender.id}`}
                  >
                    {capitalCaseNormalizer(user.recommender.name)}{" "}
                    {canEdit && (
                      <small>
                        (
                        <NumberFormat
                          value={user.recommenderPercent}
                          display="percentage"
                        />
                        )
                      </small>
                    )}
                  </Typography>
                  <div>
                    <Tooltip title={<FormattedMessage id="app.changeRecommender" />}>
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          this.setState({ showChangeRecommenderDialog: true });
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={<FormattedMessage id="app.recommender.clear" />}>
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          this.setState({
                            showClearRecommenderConfirmation: true,
                          });
                        }}
                      >
                        <CancelIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div
                  color="textSecondary"
                  style={{ display: "flex" }}
                >
                  <Typography
                    paragraph
                    color="textPrimary"
                    style={{ alignSelf: "center", textDecoration: "none" }}
                  >
                    <FormattedMessage id="app.none" />
                  </Typography>
                  <div>
                    {canEdit && (
                      <>
                        <Tooltip title={<FormattedMessage id="app.changeRecommender" />}>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              this.setState({
                                showChangeRecommenderDialog: true,
                              });
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </>
        )}

        {/* beneficiário */}
        <Typography
          color="textSecondary"
          variant="caption"
        >
          <FormattedMessage id="app.beneficiary" />
        </Typography>
        {user.beneficiary ? (
          <>
            <div
              color="textSecondary"
              style={{ display: "flex" }}
            >
              <Typography
                paragraph
                color="textPrimary"
                style={{ alignSelf: "center", textDecoration: "none" }}
              >
                {capitalCaseNormalizer(user.beneficiary.name)} {canEdit && <small>({user.beneficiary.relationship})</small>}
              </Typography>
              <div>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    this.setState({ showBeneficiaryDialog: true });
                  }}
                >
                  <ViewIcon fontSize="small" />
                </IconButton>
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              color="textSecondary"
              style={{ display: "flex" }}
            >
              <Typography
                paragraph
                color="textPrimary"
                style={{ alignSelf: "center", textDecoration: "none" }}
              >
                <FormattedMessage id="app.none" />
              </Typography>
            </div>
          </>
        )}

        {/* observações */}
        {[Roles.Admin, Roles.Kyc, Roles.FinanceManager].includes(currentUser.role) && (
          <>
            <Typography
              color="textSecondary"
              variant="caption"
            >
              <FormattedMessage id="app.obs" />
            </Typography>
            <Typography
              paragraph
              style={{ whiteSpace: "pre-line" }}
            >
              {user.observations ?? "N/A"}
            </Typography>
          </>
        )}

        {canEdit && (
          <FormChangeRecommender
            open={this.state.showChangeRecommenderDialog}
            onClose={() => {
              this.setState({ showChangeRecommenderDialog: false });
            }}
            onSuccess={() => this.loadData()}
            user={user}
            currentUser={currentUser}
            hierarchyViewType={HierarchyViewTypeEnum.ALL}
            actionEditRecommender={actions.changeRecommenderAdmin}
            actionRemoveRecommender={this.clearRecommender}
          />
        )}

        {user.beneficiary && (
          <FormDialog
            title="app.beneficiary"
            open={showBeneficiaryDialog}
            variant="secondary"
            noHeader
            onClose={(e) => this.setState({ showBeneficiaryDialog: false })}
          >
            <InfoItem
              caption={<FormattedHTMLMessage id="app.relationship" />}
              text={user.beneficiary.relationship}
            />
            <InfoItem
              caption={<FormattedHTMLMessage id="app.name" />}
              text={user.beneficiary.name}
            />
            <InfoItem
              caption={<FormattedHTMLMessage id="app.email" />}
              text={user.beneficiary.email}
            />
            <InfoItem
              caption={<FormattedHTMLMessage id="app.phone" />}
              text={user.beneficiary.phone}
            />
            <InfoItem
              caption={<FormattedHTMLMessage id="app.address" />}
              text={user.beneficiary.address}
            />
            <InfoItem
              caption={<FormattedHTMLMessage id="app.documentType" />}
              text={user.beneficiary.documentType}
            />
            <InfoItem
              caption={<FormattedHTMLMessage id="app.documentId" />}
              text={user.beneficiary.documentId}
            />
            <InfoItem
              caption={<FormattedHTMLMessage id="app.dateOfBirth" />}
              text={user.beneficiary.dateOfBirth}
            />
            <InfoItem
              caption={<FormattedHTMLMessage id="app.obs" />}
              text={user.beneficiary.observations ?? "(N/A)"}
            />
          </FormDialog>
        )}

        <Dialog open={this.state.showClearRecommenderConfirmation}>
          <DialogTitle>
            <FormattedHTMLMessage id="app.recommender.clear" />
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <FormattedHTMLMessage id="app.recommender.clear.text" />
            </DialogContentText>
            <DialogActions>
              <Button
                style={{ marginTop: 16 }}
                variant="outlined"
                onClick={(e) => {
                  this.clearRecommender();
                }}
              >
                <FormattedMessage id="app.ok" />
              </Button>
              <Button
                style={{ marginTop: 16 }}
                variant="outlined"
                onClick={(e) => {
                  this.setState({ showClearRecommenderConfirmation: false });
                }}
              >
                <FormattedMessage id="app.cancel" />
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </CardContent>
    );
  }
}

export default compose(connect((state) => ({}), actions))(UserDetail);
